import { computed } from '@ember/object';
import InductorActualFilterAmplitude from '../common/actual-filter-amplitude';
import * as Complex from '../../../process-data/complex';

export default InductorActualFilterAmplitude.extend({
  c1: null,
  l1: null,
  r1: null,
  opAmp: null,
  complexAlphaPlus: computed('c1', 'l1', 'r1', 'sSquared', 'sImaginary', function () {
    var sSquared = this.sSquared;
    var sImaginary = this.sImaginary;
    var complexOne = Complex.createComplex(1, 0);

    var c1 = this.c1;
    var l1 = this.l1;
    var r1 = this.r1;

    var result = complexOne.divide(Complex.createComplex(l1 * c1 * sSquared + 1, r1 * c1 * sImaginary));
    return result;
  }),
  inputImpedance: computed('r1', 'c1', 'l1', 'sImaginary', function () {
    var r1 = this.r1;
    var l1 = this.l1;
    var c1 = this.c1;
    var sImaginary = this.sImaginary;
    var result = Complex.createComplex(r1, l1 * sImaginary - 1 / (c1 * sImaginary));
    return result;
  }),
});
